import React from 'react';
import { useContext, createContext } from 'react';

export type TargetType = 'dev' | 'staging' | 'prod';

interface TargetContextType {
  target: TargetType;
}

const TargetContext = createContext<TargetContextType>({
  target: 'dev',
});

export function TargetContextProvider({
  children,
  target,
}: {
  children: any;
  target: TargetType;
}) {
  return (
    <TargetContext.Provider
      value={{
        target: target || 'dev',
      }}
    >
      {children}
    </TargetContext.Provider>
  );
}

export function useTargetContext() {
  const context = useContext(TargetContext);
  if (context === undefined) {
    throw new Error('Target context must be used within a Provider');
  }
  return context;
}
